<div class="card border-0 bg-transparent">
  <div class="card-header">
    <h5 class="card-title mb-1">Employee External Business Interest Declaration</h5>
    <p class="card-text text-muted">HONG KONG</p>
  </div>
  <div class="card-body">
    <p>
      To: Legal and Compliance Department Compagnie d'Investissements et de Gestion Priv&eacute;e (Hong Kong) Limited
      (&ldquo;CIGP HK&rdquo;)
    </p>
    <p>Re: Employee External Business Interest Declaration</p>
    @if (hasLastYearData) {
      <ad-alert-data-preloaded />
    }
    <form [formGroup]="form">
      <p>Please note that I, {{ name$ | async }}, would like to notify CIGP HK on the following:</p>
      <div class="mb-3 d-flex align-items-center gap-2">
        <ejs-switch formControlName="hasExternalBusinessInterest" />
        {{ hasExternalBusinessInterestLabel }}
      </div>

      @if (hasExternalBusinessInterest) {
        <ng-container formArrayName="businessInterests">
          @for (businessInterest of businessInterests.controls; track businessInterest; let i = $index) {
            <div class="d-flex align-items-center" [formGroup]="getAsFormGroup(businessInterest)">
              <div class="card flex-grow-1 mb-3">
                <div class="card-header">
                  <h6 class="card-subtitle text-muted mb-0">Business Interest {{ i + 1 }}</h6>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <label class="form-label">Name of organization and nature of business</label>
                    <ejs-textbox
                      class="e-outline"
                      formControlName="name"
                      multiline="true"
                      placeholder="Name of organization and nature of business"
                    ></ejs-textbox>
                    @if (businessInterest.get('name')?.hasError('required')) {
                      <div class="text-danger small mt-1">Name of organization and nature of business is required</div>
                    }
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Role</label>
                    <ejs-dropdownlist
                      formControlName="role"
                      [dataSource]="roles"
                      placeholder="Select a role"
                    ></ejs-dropdownlist>
                    @if (businessInterest.get('role')?.hasError('required')) {
                      <div class="text-danger small mt-1">Role is required</div>
                    }
                  </div>
                  @if (businessInterest.get('role')?.value === other) {
                    <div class="mb-3">
                      <label class="form-label">Role Description</label>
                      <ejs-textbox placeholder="Please describe the role" formControlName="roleOther"></ejs-textbox>
                      @if (businessInterest.get('roleOther')?.hasError('required')) {
                        <div class="text-danger small mt-1">Role description is required</div>
                      }
                    </div>
                  }
                  <div class="mb-3">
                    <label class="form-label">Date of commencement</label>
                    <ejs-datepicker
                      formControlName="dateOfCommencement"
                      placeholder="DD/MM/YYYY"
                      format="dd/MM/yyyy"
                    ></ejs-datepicker>
                    @if (businessInterest.get('dateOfCommencement')?.hasError('required')) {
                      <div class="text-danger small mt-1">Date of commencement is required</div>
                    }
                  </div>
                </div>
              </div>
              @if (businessInterests.length > 1) {
                <button
                  class="btn btn-outline-danger ms-2"
                  (click)="removeBusinessInterest(i)"
                  [disabled]="alreadySubmitted"
                  type="button"
                >
                  <i class="bi bi-dash-circle"></i>
                </button>
              }
            </div>
          }
          <div>
            <button
              class="btn btn-outline-primary"
              (click)="addBusinessInterest()"
              title="Add business interest"
              [disabled]="alreadySubmitted"
              type="button"
            >
              <i class="bi bi-plus-circle"></i> Add Business Interest
            </button>
          </div>
        </ng-container>
      }

      <div class="mb-3">
        <ejs-textbox
          formControlName="additionalInformation"
          multiline="true"
          placeholder="Additional information (optional)"
          floatLabelType="Auto"
          style="height: 120px"
        />
      </div>

      @if (alreadySubmitted) {
        <p><strong>Acknowledgement and Confirmation by the Employee:</strong></p>
        <p>
          Name: {{ employee }}<br />
          Date: {{ declarationDate | date }}
        </p>
      }
    </form>
    <div class="btn-group">
      @if (alreadySubmitted) {
        <button class="btn btn-primary" disabled>YOU ALREADY SUBMITTED THIS DECLARATION</button>
      } @else {
        <button
          class="btn btn-primary"
          [disabled]="!form.valid || !form.get('additionalInformation')?.valid"
          (click)="submitForm()"
        >
          SUBMIT
        </button>
      }
      <button class="btn btn-secondary" (click)="location.back()">BACK</button>
    </div>
  </div>
</div>

<!-- Syncfusion Acknowledgement Dialog -->
<ejs-dialog #ackDialog [(visible)]="showAckDialog" width="600px" [isModal]="true">
  <ad-external-business-interest-declaration-ack-dialog
    [data]="ackDialogData"
    (closeDialog)="handleDialogClose($event)"
  >
  </ad-external-business-interest-declaration-ack-dialog>
</ejs-dialog>
